//
// Serializer.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./SerializationStyle";

var Serializer = createModule("commons::Serializer", [], ClosetObject, [
    ,
    ,
    ,
    {
        xmlDeclaration: 2,
        style: 4,
    },
    {
        serialize: [7,1,4,4],
    },
    {
        _create: [4],
    },
    ,
]);
export default Serializer;
